export enum HeaderKeys {
  XHaChannel = 'x-ha-channel',
  XHaBusinessDomain = 'x-ha-business-domain',
  ContentType = 'Content-Type',
  XRootCorrelationId = 'x-root-correlation-id',
  Authorization = 'Authorization',
  XRootSessionId = 'x-root-session-id',
}
